import axios from "axios";
import Config from "../utils/Config";
import Middleware from "./Middleware";


class RestService {
  config = {
    headers: {
      Authorization: "",
      CompanyId: "",
    },
  };

  setAccessToken(accessToken, companyId) {
    this.config.headers.Authorization = accessToken;
    this.config.headers.CompanyId = companyId;
  }


  // get
  async getBranchDataByCompanyId(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get("/api/branch", this.config);
    return res.data;
  }

  // get
  async getBranchDataByCompanyIdForMasterData(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get("/api/branch", this.config);
    return res;
  }

  async getRoleDataByCompanyId(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get("/api/role", this.config);
    return res.data;
  }

  async getRestrictedRoleDataByCompanyId(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get("/api/role/restricted", this.config);
    return res.data;
  }

  async getRoleDataByCompanyIdForUserDropdown(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get("/api/role/dropdown", this.config);
    return res.data;
  }

  async getDepartmentsDataByCompanyId(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get("/api/department", this.config);
    return res;
  }

  async getUsersDataByCompanyId(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get("/api/userDetails/usersByCompanyId", this.config);
    return res.data;
  }

  async getActiveUsersDataByCompanyId(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get("/api/userDetails/activeUsersByCompanyId", this.config);
    return res.data;
  }

  async getCommitteeDataByCompanyId(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get("/api/committeeType/byUserDetailsId/forPrivileged", this.config);
    return res;
  }

  async getCommitteeTypeDataByCompanyId(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get("/api/committeeType/", this.config);
    return res;
  }

  async getCommitteeTypesListForMeetingFilter(userId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get(`/api/committeeType/byUserDetailsId/forGeneral`, this.config);
    return res;
  }

  async getCommitteesListForMeetingFilter(committeeTypeId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get(`/api/committee/byCommitteeTypeAndUserDetailsId/${committeeTypeId}/forGeneral`, this.config);
    return res;
  }

  async getCommitteeListByCompanyId(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get("/api/committee/byCompany", this.config);
    return res.data;
  }
  
  async getCommitteeListDetailsByCompanyId(companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get("/api/committee/byCompanyWithMemberInfos", this.config);
    return res.data;
  }

  async getCommitteeDataByCommitteeId(committeeId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get(`/api/committee/byIdWithMembers/${committeeId}`, this.config);
    return res.data;
  }

  async getCommitteeListByCommitteeTypeId(committeeTypeId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get(`/api/committee/byCommitteeType/${committeeTypeId}`, this.config);
    return res.data;
  }

  async getUserListByBranchId(branchId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.get(`/api/userDetails/users/?branchId=${branchId}`, this.config);
    return res.data;
  }

  // create
  async createBranch(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.post("/api/branch", formData, this.config);
    return res.data;
  }

  async createRole(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.post("/api/role", formData, this.config);
    return res.data;
  }

  async createDepartment(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.post("/api/department", formData, this.config);
    return res.data;
  }

  async createUser(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.post("/api/auth/registerUser", formData, this.config);
    return res.data;
  }

  async createCommitteeConf(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.post("/api/committeeType", formData, this.config);
    return res.data;
  }

  async createCommittee(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.post("/api/committee", formData, this.config);
    return res.data;
  }

  async createMeeting(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.post("/apiVWeb/meeting", formData, this.config);
    return res;
  }




  // update
  async updateUser(userId, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.put(`/api/userDetails/${userId}`, formData, this.config);
    return res.data;
  }

  async updateBranch(branchId, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.put(`/api/branch/${branchId}`, formData, this.config);
    return res.data;
  }

  async updateRole(roleId, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.put(`/api/role/${roleId}`, formData, this.config);
    return res.data;
  }

  async updateDepartment(departmentId, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.put(`/api/department/${departmentId}`, formData, this.config);
    return res.data;
  }

  async updateCommitteeConfig(committeeConfigId, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.put(`/api/committeeType/${committeeConfigId}`, formData, this.config);
    return res.data;
  }

  // async updateSingleCommittee (selectedCommitteeID, formData, companyId, accessToken){
  //   this.setAccessToken(accessToken, companyId);

  //   const data = await axios.put(
  //       Config.BACKEND_URL + `/api/committee/${selectedCommitteeID}`,
  //       formData,
  //       this.config
  //     )
  //     return data.data;
  // }

  // this version of API call use newly created centralized error handling
  async updateSingleCommittee(selectedCommitteeID, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.put(`/api/committee/${selectedCommitteeID}`, formData, this.config);
    return res.data;
  }

  async updateStatusBranch(branchId, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.patch(`/api/branch/${branchId}`, formData, this.config);
    return res.data;
  }


  // update status

  async updateStatusUser(userId, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.patch(`/api/userDetails/status/${userId}`, formData, this.config);
    return res.data;
  }

  async updateStatusRole(roleId, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.patch(`/api/role/${roleId}`, formData, this.config);
    return res.data;
  }

  async updateStatusDepartment(departmentId, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.patch(`/api/department/${departmentId}`, formData, this.config);
    return res.data;
  }

  async updateStatusCommitteeConfig(committeeConfigId, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.patch(`/api/committeeType/${committeeConfigId}`, formData, this.config);
    return res.data;
  }

  async updateCommitteeStatus(committeeId, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.patch(`/api/committee/${committeeId}`, formData, this.config);
    return res.data;
  }

  // delete
  async deleteBranch(branchId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.delete(`/api/branch/${branchId}`, this.config);
    return res.data;
  }

  async deleteRole(roleId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.delete(`/api/role/${roleId}`, this.config);
    return res.data;
  }

  async deleteUser(userId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.delete(`/api/userDetails/${userId}`, this.config);
    return res.data;
  }

  async unlockUser(userId, formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.patch(`/api/userDetails/unlock/${userId}`, formData, this.config);
    return res.data;
  }

  async deleteDepartment(departmentId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.delete(`/api/department/${departmentId}`, this.config);
    return res.data;
  }

  async deleteCommitteeConfig(committeeConfigId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.delete(`/api/committeeType/${committeeConfigId}`, this.config);
    return res.data;
  }

  async deleteSingleCommittee(committeeId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const res = await Middleware.api.delete(`/api/committee/${committeeId}`, this.config);
    return res.data;
  }


  async analyzeFile(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      ...this.config
    }
    const res = await Middleware.api.post("/api/fileUpload/analyze-file", formData, config);
    return res.data;
  }

  async uploadFile(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      ...this.config
    }
    const res = await Middleware.api.post("/api/fileUpload/register-csv", formData, config);
    return res.data;
  }

}

export default new RestService();
